import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { TipoParentesco, TipoPlano, TipoSolicitacao } from 'app/model/solicitacaoAuxSaude';
import { SolicitacaoAuxSaudeService } from 'app/service/solicitacao-aux-saude/solicitacao-aux-saude.service';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { Location } from '@angular/common';
import { forkJoin, Observable } from "rxjs";
import { Enum } from "../../model/enum";
import { EnumService } from "../../service/enum/enum";

@Component({
  selector: 'app-detalhes-solicitacao',
  templateUrl: './detalhes-solicitacao.component.html',
  styleUrls: ['./detalhes-solicitacao.component.sass']
})
export class DetalhesSolicitacaoComponent implements OnInit {
  form: FormGroup = null;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['nomeCompleto', 'acoes']
  solicitacaoId: number = null;
  idPessoa: number = null;
  listaEstadoCivil: Enum[];
  listaTipoCapacidade: Enum[];
  listaTipoParentesco: TipoParentesco[];
  listaTipoPlanos: TipoPlano[];
  listaTipoSolicitacao: TipoSolicitacao[] = [];
  totalElements: number;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private solicitacaoAuxSaudeService: SolicitacaoAuxSaudeService,
    private enumService: EnumService,
    private toasterService: ToastrService,
    private location: Location) { }

  ngOnInit(): void {
    this.extractIdFromUrl();
    this.createForm();
    this.loadDados(this.solicitacaoId);

  }

  extractIdFromUrl() {
    this.solicitacaoId = this.route.snapshot.params.id ?? null;
    this.idPessoa = this.route.snapshot.params.idPessoa ?? null;
  }

  getTipoPlanos(): Observable<TipoPlano[]>{
    return this.solicitacaoAuxSaudeService.getTipoPlanos()
  }

  getTipoParentesco(): Observable<TipoParentesco[]>{
    return this.solicitacaoAuxSaudeService.getTipoParentesco()
  }

  getEstadoCivil(): Observable<Enum[]>{
    return this.enumService.buscarEstadoCivil();
  }

  getTipoCapacidade(): Observable<Enum[]>{
    return this.solicitacaoAuxSaudeService.getTipoCapacidade();
  }

  getTipoSolicitacao(): Observable<TipoSolicitacao[]>{
    return this.solicitacaoAuxSaudeService.getTipoSolicitacao();
  }

  changeCapacidade($event: any) {
    if($event.source.value == 3){
      this.form.get('dataInvalidez').setValidators(Validators.required);
    } else {
      this.form.get('dataInvalidez').clearValidators();
      this.form.get('dataInvalidez').updateValueAndValidity();
    }
  }

  loadDados(id: number) {
    const tipoSolicitacao$: Observable<TipoSolicitacao[]> = this.getTipoSolicitacao();
    const tipoPLano$: Observable<TipoPlano[]> = this.getTipoPlanos();
    const tipoParentesco$: Observable<TipoParentesco[]> = this.getTipoParentesco();
    const estadoCivil$: Observable<Enum[]> = this.getEstadoCivil();
    const tipoCapacidade$: Observable<Enum[]> = this.getTipoCapacidade();
    forkJoin([tipoSolicitacao$, tipoPLano$, tipoParentesco$, estadoCivil$, tipoCapacidade$ ])
      .pipe()
      .subscribe(
        ([tipoSolicitacao, tipoPLano, tipoParentesco, estadoCivil, tipoCapacidade]) => {
          this.listaTipoSolicitacao = tipoSolicitacao;
          this.listaTipoPlanos = tipoPLano;
          this.listaTipoParentesco = tipoParentesco;
          this.listaEstadoCivil = estadoCivil;
          this.listaTipoCapacidade = tipoCapacidade;
          this.solicitacaoAuxSaudeService.getVisualizarSolicitacao(id).subscribe((result) => {
            this.fillForm(result);
            this.solicitacaoAuxSaudeService.getVisualizarListaAnexosSolicitacao(
              this.idPessoa, this.form.get('dependente').value
            ).subscribe((result) => {
              this.dataSource.data = result;
              this.totalElements = this.dataSource.data.length;
            }, error => {
              this.toasterService.error(error.error.message)
            })
          }, error => {
            this.toasterService.error(error.error.message)
          })
        },
        (error) => {
          this.toasterService.error(error.error.message)
        }
      );
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      //Tipo de Solicitação
      tipoSolicitacao: [{ value: null, disabled: true }],
      dependente: [{ value: null, disabled: true }],
      tipoPlano: [{ value: null, disabled: true }],
      nomePlano: [{ value: null, disabled: true }],
      valorPlano: [{ value: null, disabled: true }],
      //Dependente
      cpfDependente: [{ value: null, disabled: true }],
      nomeDependente: [{ value: null, disabled: true }],
      dataNascimentoDependente: [{ value: null, disabled: true }],
      tipoParentesco: [{ value: null, disabled: true }],
      srh: [{ value: null, disabled: true }],
      sexo: [{ value: null, disabled: true }],
      estadoCivil: [{ value: null, disabled: true }],
      tipoCapacidade: [{ value: null, disabled: true }],
      dataInvalidez: [{ value: null, disabled: true }],
    });
  }

  fillForm(data) {
    const dados = data.dependentes.concat(data.titular).find(element => element.id == this.idPessoa);
    if (dados) {
      this.form.get('tipoSolicitacao').setValue(dados.tipoSolicitacaoId);
      this.form.get('dependente').setValue(dados.tipoDependente);
      this.form.get('tipoPlano').setValue(dados.tipoPlanoId);
      this.form.get('nomePlano').setValue(dados.nomePlanoSaude);
      this.form.get('valorPlano').setValue(dados.valor);
      if (dados.tipoDependente) {
        this.form.get('cpfDependente').setValue(dados.cpf);
        this.form.get('nomeDependente').setValue(dados.nome);
        this.form.get('dataNascimentoDependente').setValue(dados.dataNascimento);
        this.form.get('tipoParentesco').setValue(dados.tipoParentescoId);
        this.form.get('sexo').setValue(dados.sexo);
        this.form.get('estadoCivil').setValue(dados.estadoCivil);
        this.form.get('tipoCapacidade').setValue(dados.tipoCapacidade);
        this.form.get('dataInvalidez').setValue(dados.dataInvalidez);
        this.form.get('srh').setValue(dados.estaSrh?"SIM":"NÃO");
      }
    }
  }

  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toasterService.success('Arquivo baixado com sucesso');
  }

  download(anexo) {
    const data = {
      id: anexo.id,
      //isDependente: this.form.get('dependente').value
    }
    this.solicitacaoAuxSaudeService.getAnexoSolicitacao(data).subscribe((response: Blob) => {
      const fileName = `${anexo.descricao}.pdf`;
      const blob = new Blob([response], { type: 'application/octet-stream' });
      // Inicia o download do arquivo
      this.downloadFile(blob, fileName);
    })
  }

  voltar() {
    this.location.back();
  }

}
